import React from 'react'

import { Card, CardHeader, CardContent, Grid } from '@material-ui/core'

import PageInfo from '../../PageInfo/PageInfo'
import FileDropper from '../../UI/FileDropper/FileDropper'
import ExportBox from './ExportBox/ExportBox'

const ImportSalaryContent = ({
  fileChanged,
  uploadFileProgress,
  exportClicked,
  loadingQueue,
  translate
}) => {
  return (
    <Card>
      <CardHeader title={<PageInfo pageTranslateKey={'importSalary'} translate={translate} />} />
      <CardContent>
        <Grid container spacing={2} alignItems={'center'} justify={'space-evenly'}>
          <Grid item xs={12} md={6}>
            <FileDropper
              fileChanged={fileChanged}
              uploadProgress={uploadFileProgress}
              acceptFormat={
                '.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
              }
              loading={loadingQueue.includes('import')}
              translate={translate}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <ExportBox
              clicked={exportClicked}
              loading={loadingQueue.includes('export')}
              translate={translate}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default ImportSalaryContent
